import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import {sendOtpzip} from '../../http/http'

const RegisterZipGame = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState("");

  const handleNext = async() => {
    if (!msisdn.trim()) return;
   try {
    await sendOtpzip(msisdn).then(
       navigate("/verify-otp/zip-game", {
      state: { msisdn },
    }))
   } catch (error) {
    console.log(error);
    
   }
   
  };

  return (
    <>
      <Header />

      <div className={classes.container}>

        <div className={classes.header_section}>
          <div className={classes.back_button} onClick={() => {
            navigate("/");
          }}>
            <FaArrowLeft className={classes.back_icon} />
          </div>
        </div>


        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>{t("173")}</div>
          <h1 className={classes.heroTitle}>{t("174")}</h1>
          <p className={classes.heroText}>
            {t("175")}
          </p>
        </div>

        <ZipGameStepper currentStep={1} />

        <div className={classes.formCard}>
          <div className={classes.section}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>{t("176")}</h2>
              <p className={classes.sectionText}>
                {t("177")}
              </p>
            </div>

            <div className={classes.inputGroup}>
              <label className={classes.label} htmlFor="msisdn">
                {t("178")}
              </label>

              <div className={classes.phoneField}>
                <div className={classes.countryBox}>
                  <img
                    src="/assets/images/FlagGB.png"
                    alt="flag"
                    className={classes.flag}
                  />
                  <span className={classes.code}>+245</span>
                </div>

                <input
                  id="msisdn"
                  type="number"
                  className={classes.input}
                  placeholder={t("179")}
                  value={msisdn}
                  onChange={(e) => setMsisdn(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>

            <div className={classes.infoBox}>
              <p>
                {t("180")}
              </p>
            </div>

            <button type="button" className={classes.primaryBtn} onClick={handleNext}>
              {t("181")}
            </button>

            {/* here it will be the login option */}
            <p className={classes.link_text}>
              {t("182")}<span onClick={() => navigate("/login/zip-game")}>{t("183")}</span>
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterZipGame;